import moment from 'moment';
import { DISPLAY_DATE_FORMAT, BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '../../../common/js/vuex/oki-store';
import { SUMMARY_HEADER_HEIGHT, ROUTE_NAMES, DEBUG } from '../constants/oki-constants';
import offset from 'document-offset';
const getValue = (list, key, arrayKey) => {
	let retVal = null;
	arrayKey = arrayKey || 'code';
	let filteredList = list.filter((item) => {
		return item[arrayKey] == key;
	});
	if (filteredList.length) {
		retVal = filteredList[0].displayValue;
	}
	return retVal;
};
const FORINT = 'Ft';
const HUF = 'huf';
const getBankBranchAddress = (list, key) => {
	let retVal = null;
	let filteredList = list.filter((item) => {
		return item.branchCode === key;
	});
	if (filteredList.length) {
		retVal = filteredList[0];
	}
	return retVal;
};
const PURCHASE_LIMIT_MAX = 'Számlaegyenleg erejéig';
const DEBITCARD_API = '/apps/debitcard';

const TA_EVENTS = {
	OKI: {
		progressBarNavigation: 'OKI_OSSZEGZES_SZERKESZTEM',
		editFromSummaryAccordion: 'OKI_OSSZEGZES_MODOSITANI'
	},
	SOKI: {
		progressBarNavigation: 'SOKI_OSSZEGZES_SZERKESZTEM',
		editFromSummaryAccordion: 'SOKI_OSSZEGZES_MODOSITANI'
	}
};

export default {
	data() {
		return {
			purchaseLimitMaxText: PURCHASE_LIMIT_MAX,
			debitcardApi: DEBITCARD_API,
			accordions: ['1', '2', '3', '4', '5', '6']
		};
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		convertedPersonalData() {
			let personalData = Object.assign({}, this.personalData);
			if (Object.keys(personalData).length !== 0) {
				personalData.dateOfBirth = moment(this.personalData.dateOfBirth, BACKEND_DATE_FORMAT).format(DISPLAY_DATE_FORMAT[this.$i18n.locale]);
				personalData.mobileProviderText = this.findMobileProvider(personalData.mobileProvider);
				personalData.notificationMethod = this.personalData.notificationMethod === 'SMS' ? 'SMS-ben' : 'E-mailben';
				personalData.addressLine = this.personalData.postalCode + ' ' + this.personalData.settlement + ', ' + this.personalData.address;
				personalData.bankBranchAddress = getBankBranchAddress(this.bankBranches, this.personalData.handoverBranch.code);
			}

			return personalData;
		},
		convertedFinancialData() {
			let financialData = Object.assign({}, this.financialData);
			financialData.usageScope = getValue(this.usageScopes, this.financialData.usageScope);
			return financialData;
		},
		...mapState({
			personalData: (state) => state.personal.personalData,
			bankBranches: (state) => state.personal.bankBranches,
			financialData: (state) => state.financial.financialData
		}),
		...mapState(['mobileProviders', 'usageScopes', 'soki', 'cardData', 'counties', 'currency']),
		...mapGetters(['getImage']),
		currentCurrency() {
			return this.currency.toLowerCase() == HUF ? FORINT : this.currency;
		}
	},
	methods: {
		accordionChange() {
			if (this.isMobile) {
				setTimeout(() => {
					this.sendHeightEvent();
				});
			}
		},
		findMobileProvider(providerCode) {
			let result = '';
			for (let provider in this.mobileProviders) {
				if (this.mobileProviders.hasOwnProperty(provider)) {
					if (this.mobileProviders[provider].code == providerCode) {
						result = this.mobileProviders[provider].displayValue;
					}
				}
			}
			return result;
		},
		sendTa(fromSummaryAccordion) {
			let okiSoki = this.soki ? 'SOKI' : 'OKI';
			let taData = fromSummaryAccordion ? TA_EVENTS[okiSoki].editFromSummaryAccordion : TA_EVENTS[okiSoki].progressBarNavigation;
			this.postTaData({ vhk: false, taData });
		},
		...mapActions(['postAllForms', 'postTaData'])
	},
	beforeRouteEnter(to, from, next) {
		if (
			(from.path == ROUTE_NAMES.KARTYAESSZAMLA && !store.state.soki) ||
			(from.path == ROUTE_NAMES.KARTYAKEP && store.state.soki) ||
			store.state.visitedPages.indexOf(to.path) != -1 ||
			DEBUG
		) {
			store.dispatch('setCurrentPage', to.path);
			if (store.state.visitedPages.indexOf(to.path) == -1) {
				store.dispatch('addVisitedPages', to.path);
			}
			next();
		} else {
			next(ROUTE_NAMES.SZEMELYES);
		}
	},
	beforeRouteLeave(to, from, next) {
		let fromSummaryAccordion = !!(to.query && to.query.summary);
		this.sendTa(fromSummaryAccordion);
		next();
	},
	mounted() {
		setTimeout(() => {
			if (!this.isMobile) {
				let elem = document.querySelector('#oki-progress-bar');
				window.scroll(0, elem && offset(elem).top ? offset(elem).top : 0);
			} else {
				window.scroll(0, offset(this.$el).top - SUMMARY_HEADER_HEIGHT);
			}
			if (this.$refs['summary-title']) {
				this.$refs['summary-title'].focus();
			}
		});
	}
};
